import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Jobs from "./pages/Jobs";
import JobApplication from "./pages/JobApplication";
import JobDetails from "./pages/JobDetails";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Termsofuse from "./pages/Termsofuse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CreateAccount from "./pages/CreateAccount";
import VerifyEmail from "./pages/VerifyEmail";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Applications from "./pages/Applications";
import ScrollToTop from "./ScrollToTop";
import Preloader from "./components/preloader";
import * as analytics from "./utils/analytics";

// Redirect /jobs/:id/apply to /careers/:id/apply
function RedirectJobsIdToCareers() {
  const { id } = useParams();
  return <Navigate to={`/careers/${id}/apply`} replace />;
}

// Redirect /jobs/:id to /careers/:id
function RedirectJobIdToCareers() {
  const { id } = useParams();
  return <Navigate to={`/careers/${id}`} replace />;
}

function AnalyticsPageView() {
  const location = useLocation();
  useEffect(() => {
    analytics.trackPageView(location.pathname, document.title);
  }, [location.pathname]);
  return null;
}

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    analytics.init();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {!loading ? (
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <ScrollToTop />
            <AnalyticsPageView />
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/careers" element={<Jobs />} />
            <Route path="/jobs" element={<Navigate to="/careers" replace />} />
            <Route path="/careers/:id/apply" element={<JobApplication />} />
            <Route path="/jobs/:id/apply" element={<RedirectJobsIdToCareers />} />
            <Route path="/careers/:id" element={<JobDetails />} />
            <Route path="/jobs/:id" element={<RedirectJobIdToCareers />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/termsofuse" element={<Termsofuse />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/cookiepolicy" element={<CookiePolicy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<CreateAccount />} />
            <Route path="/signup" element={<Navigate to="/register" replace />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            {/* Protected Routes - Require Authentication */}
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/applications" 
              element={
                <ProtectedRoute>
                  <Applications />
                </ProtectedRoute>
              } 
            />
          </Routes>
          </AuthProvider>
        </Router>
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default App;
